export default "__VITE_ASSET__BSYSNNsa__"